// There will only be a single occurrence of decimal separator either a point (.) or comma (,)
// Other value will be flagged out as invalid in the form validation
// Conversion is done by replacing the last occurrence of comma (,) with a point (.)
// Final value should always be in point decimal format that is sent to the server
function convertDecimalSeparatorCommaToPeriod(value: string) {
    const lastIndex = value.lastIndexOf(',');
    if (value.lastIndexOf(',') !== -1) return value.slice(0, lastIndex) + '.' + value.slice(lastIndex + 1);
    return value;
}

function isFormValueEmptyNullOrUndefined(amountResultFormValue: string | number | undefined | null) {
    return (
        amountResultFormValue === '' || amountResultFormValue === null || amountResultFormValue === undefined
    );
}

export function convertFormValueToNumberOrUndefined(
    amountResultFormValue: string | number | undefined | null,
) {
    if (isFormValueEmptyNullOrUndefined(amountResultFormValue)) return undefined;
    amountResultFormValue = convertDecimalSeparatorCommaToPeriod(amountResultFormValue!.toString());
    return isNaN(Number(amountResultFormValue)) ? undefined : Number(amountResultFormValue);
}

export function isNumberWithPointSeparator(s: string) {
    // Allow value with either , or . as a decimal separator
    return !!s.match(/^\s*\d*\.?\d*\s*$/) || !!s.match(/^\s*\d*,?\d*\s*$/);
}
